<agr-dialog [data]="data" (confirm)="confirm()" (cancel)="cancel()" (alt)="alt()">
  <p class="flex--row">
    <app-copy-cropfields-to-manure-space-progress
      class="flex__child--auto"
    ></app-copy-cropfields-to-manure-space-progress>
  </p>
</agr-dialog>
